export const PURCHASE_INTENTION_DEFAULT_SOLR_PARAMS = {
  beginTime: "",
  endPlanPurchaseAmount: "",
  endPlanPurchaseDate: "",
  endTime: "",
  excludeWord: "",
  filterMode: "2,1,10",
  formSource: "4", // 4 搜产品 5 搜企业
  keyword: "",
  keywordsAndOr: "|", // 且或关系、& = 且 、 | = 或
  newAreas: "",
  purchaseDateType: "",
  purchasingUnitIdList: "",
  searchMode: "",
  smallFilterMode: "2,1,10",
  smallKeywords: "",
  startPlanPurchaseAmount: "",
  startPlanPurchaseDate: "",
  threeClassifyTagStr: "",
  timeType: "8",
  T: "",
  sortType: "2",
  summaryType: "0",
};

export const PURCHASE_INTENTION_TIME_LIST = [
  {
    id: 7,
    text: "当日",
  },
  {
    id: 2,
    text: "近7天",
  },
  {
    id: 3,
    text: "近30天",
  },
  {
    id: 8,
    text: "近90天",
  },
  {
    id: 9,
    text: "近半年",
  },
  {
    id: 1,
    text: "近一年",
  },
  {
    id: 40,
    text: "往年",
  },
  {
    id: 4,
    text: "自定义",
  },
];
export const PURCHASE_INTENTION_PROCUREMENT_TIME_LIST = [
  {
    id: 1,
    text: "本月",
  },
  {
    id: 2,
    text: "下月",
  },
  {
    id: 3,
    text: "两个月后",
  },
  {
    id: 99,
    text: "自定义",
  },
];

export const PURCHASE_INTENTION_AMOUNT = [
  {
    id: -1,
    startPlanPurchaseAmount: "",
    endPlanPurchaseAmount: "",
    text: "不限",
  },
  {
    id: 2,
    startPlanPurchaseAmount: "",
    endPlanPurchaseAmount: "100000",
    text: "10万以下",
  },
  {
    id: 3,
    startPlanPurchaseAmount: "100000",
    endPlanPurchaseAmount: "500000",
    text: "10万-50万",
  },
  {
    id: 4,
    startPlanPurchaseAmount: "500000",
    endPlanPurchaseAmount: "1000000",
    text: "50万-100万",
  },
  {
    id: 5,
    startPlanPurchaseAmount: "1000000",
    endPlanPurchaseAmount: "2000000",
    text: "100万-200万",
  },
  {
    id: 6,
    startPlanPurchaseAmount: "2000000",
    endPlanPurchaseAmount: "",
    text: "200万以上",
  },
  {
    id: 99,
    startPlanPurchaseAmount: "",
    endPlanPurchaseAmount: "",
    text: "",
    hide: true,
  },
];
export const PURCHASE_INTENTION_SEARCH_SCOPE = [
  {
    text: "标题",
    id: 2,
  },
  {
    text: "正文",
    id: 1,
    tip: "公告正文内容，不包含标题和附件",
  },
  {
    text: "附件",
    id: 10,
    tip: "公告中的附件文件，非文本类附件可能识别不完整",
  },
];
export const PURCHASE_INTENTION_MODE_LIST = [
  {
    id: 1,
    text: "精准",
    tip: "关键词完整出现在目标搜索范围中",
  },
  {
    id: 0,
    text: "模糊",
    tip: "关键词根据语义自动拆分，出现在目标搜索范围的不同位置",
  },
];
export const PURCHASE_INTENTION_SMALL_SEARCH_SCOPE = [
  {
    text: "搜全部",
    id: -2,
  },
  {
    text: "搜标题",
    id: 2,
  },
  {
    text: "搜正文",
    id: 1,
    tip: "公告正文内容，不包含标题和附件",
  },
  {
    text: "搜附件",
    id: 10,
    tip: "公告中的附件文件，非文本类附件可能识别不完整",
  },
];
